import { render, staticRenderFns } from "./TaxCalc.vue?vue&type=template&id=597c50b6&"
import script from "./TaxCalc.vue?vue&type=script&lang=js&"
export * from "./TaxCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports